import type {
  CallFilters,
  EnterpriseFilters,
  EventFilters,
  UserFilters,
} from '@/lib/api/endpoints'
import type { MongoQuery } from '@/lib/api/types'

/** Every React Query key in the app, in one place. */
export const queryKeys = {
  me: ['me'] as const,

  users: (filters: UserFilters) => ['users', filters] as const,
  user: (uid: string) => ['user', uid] as const,

  enterprises: (filters: EnterpriseFilters) => ['enterprises', filters] as const,
  enterprise: (id: string) => ['enterprise', id] as const,

  calls: (filters: CallFilters) => ['calls', filters] as const,
  call: (callSid: string) => ['call', callSid] as const,
  liveCalls: ['calls', 'live'] as const,
  scheduledCalls: (filters: { uid?: string; status?: string; limit?: number; skip?: number }) =>
    ['calls', 'scheduled', filters] as const,

  events: (filters: EventFilters) => ['events', filters] as const,
  eventTypes: ['events', 'types'] as const,
  logs: (search: string) => ['logs', search] as const,

  stats: (params: { from?: string; to?: string; interval?: string }) => ['stats', params] as const,

  templates: ['templates'] as const,

  // debug tools
  debugCollections: ['debug', 'collections'] as const,
  debugFind: (query: MongoQuery) => ['debug', 'find', query] as const,
  cacheScan: (pattern: string, cursor: number) => ['debug', 'cache', pattern, cursor] as const,
  cacheValue: (key: string) => ['debug', 'cache', 'value', key] as const,
  ttsProviders: ['debug', 'tts', 'providers'] as const,
  llmProviders: ['debug', 'llm', 'providers'] as const,
}
